import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { useToast } from "@hooks"
import { strategiesApi } from "Pages/DsRepricing/Page/@services/api"
import { fromServer } from "Pages/DsRepricing/Page/@services/adapters"
import { dsRepricingListData, dsRepricingIsLoading } from "Pages/DsRepricing/Page/@signals"

export default function useDsRepricingTable() {
	const { showToast } = useToast()

	const getTableData = useCallback(() => {
		batch(() => {
			dsRepricingIsLoading.value = true
			dsRepricingListData.value = []
		})
		strategiesApi.list()
			.then(items => {
				batch(() => {
					dsRepricingListData.value = items.map(fromServer)
					dsRepricingIsLoading.value = false
				})
			})
			.catch(err => {
				dsRepricingIsLoading.value = false
				showToast.error(err?.message || "Error loading the repricing strategies")
			})
	}, [])

	return { getTableData }
}
